/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SearchGranteeSalesRightsMutation($input: SearchGranteeSalesRights_M_simulation_pavillon_informationInput!) {
    searchGranteeSalesRights_M_simulation_pavillon_information(input: $input) {
      ok
      error
      
        code 
    }
  }
`;

export default mutation;
